export default __webpack_public_path__ + "static/media/c.83dfa097.png";